import { useQuery } from '@tanstack/react-query';

import { getLogsByPromo } from '~/services/PromoService';

type Query = Parameters<typeof getLogsByPromo>[0];

export const promoLogQueryKeys = {
  all: ['promo-logs'] as const,
  list: (query: Query) => [...promoLogQueryKeys.all, 'list', query] as const,
};

export function useGetPromoLogs({ query, enabled = true }: { query: Query; enabled?: boolean }) {
  return useQuery({
    queryKey: promoLogQueryKeys.list(query),
    queryFn: () => getLogsByPromo(query),
    enabled: enabled && Boolean(query.codeName),
  });
}
